(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["fg-pdp-boosters"] && !Shopify.designMode) return;
  try {
    (function(){
  var root=document.querySelector('[data-fg-boost]'); if(!root) return;
  var formId=root.getAttribute('data-form-id'); var form=document.getElementById(formId);
  var details=root.closest('.product-details, product-information, .product-information')||root.parentElement;

  /* 4. Variante par défaut = première variante disponible (si l'URL pointe sur une variante épuisée) */
  function fallbackToAvailable(){
    document.querySelectorAll('fieldset.variant-option').forEach(function(fs){
      var checked=fs.querySelector('input[type=radio]:checked');
      if(checked && checked.getAttribute('data-option-available')==='false'){
        var ok=fs.querySelector('input[type=radio][data-option-available="true"]');
        if(ok){ ok.click(); }
      }
    });
  }
  setTimeout(fallbackToAvailable,50);

  /* 5. Épuisé → Notify me à la place du bouton grisé (observe l'état du bouton natif) */
  var notify=root.querySelector('[data-fg-notify]');
  function refreshSoldOut(){
    var btn=form && form.querySelector('button[name="add"]');
    var sold=!!(btn && btn.disabled);
    if(notify){ notify.hidden=!sold; }
    if(details){ details.classList.toggle('fg-boost-soldout',sold); }
    var sel=[].map.call(document.querySelectorAll('fieldset.variant-option input[type=radio]:checked'),function(i){return i.value;}).join(' / ');
    var hid=root.querySelector('[data-fg-notify-product]'); var title=document.querySelector('h1');
    if(hid && title){ hid.value=(title.textContent||'').trim()+(sel?' — '+sel:''); }
  }
  refreshSoldOut();
  if(form){ new MutationObserver(refreshSoldOut).observe(form,{subtree:true,attributes:true,attributeFilter:['disabled']}); }
  document.addEventListener('change',function(e){ if(e.target && e.target.matches('fieldset.variant-option input[type=radio]')){ setTimeout(refreshSoldOut,150); setTimeout(syncGalleryToVariant,150); } });

  /* 8. Points Joy : « Earn N points » depuis la règle publique AVADA_JOY.placeOrder (aucune promesse si mode test) */
  var ptsEl=root.querySelector('[data-fg-points]'), ptsTxt=root.querySelector('[data-fg-points-text]');
  var variantsJson=(function(){ try{ return JSON.parse(root.getAttribute('data-fg-variants')||'[]'); }catch(e){ return []; } })();
  function currentPrice(){
    var idInput=form && form.querySelector('input[name="id"]'); var vid=idInput && Number(idInput.value);
    for(var i=0;i<variantsJson.length;i++){ if(variantsJson[i].id===vid) return variantsJson[i].price; }
    return variantsJson.length?variantsJson[0].price:0;
  }
  function refreshPoints(){
    var J=window.AVADA_JOY; if(!ptsEl||!J||!J.placeOrder||J.placeOrder.status!==true){ if(ptsEl) ptsEl.hidden=true; return; }
    if(J.shop && J.shop.isTestEarningPointMode){ ptsEl.hidden=true; return; }
    var earn=Number(J.placeOrder.earnPoint)||0, rate=Number(J.placeOrder.rateMoney)||1; var price=currentPrice()/100;
    var pts=Math.floor(price/rate*earn); if(!(pts>0)){ ptsEl.hidden=true; return; }
    var label=(J.settings&&(pts>1?J.settings.pointPlural:J.settings.pointSingular))||(pts>1?'points':'point');
    ptsTxt.textContent=(root.getAttribute('data-fg-points-tpl')||'Earn {points} {label} with this box').replace('{points}',pts).replace('{label}',label);
    ptsEl.hidden=false;
  }
  var tries=0; (function waitJoy(){ if(window.AVADA_JOY||tries++>40){ refreshPoints(); } else { setTimeout(waitJoy,250); } })();
  document.addEventListener('change',function(e){ if(e.target && e.target.matches('fieldset.variant-option input[type=radio]')){ setTimeout(refreshPoints,300); } });
  var openBtn=root.querySelector('[data-fg-points-open]');
  if(openBtn){ openBtn.addEventListener('click',function(e){ e.preventDefault(); var b=document.querySelector('#Avada-Joy_FloatingButton button, .joy-fab-pure'); if(b){ b.click(); } else { location.href='/account'; } }); }

  /* 3. Gift note : n'envoie la propriété que si la case est cochée */
  var toggle=root.querySelector('[data-fg-gift-toggle]'), box=root.querySelector('[data-fg-gift-box]'), ta=root.querySelector('[data-fg-gift-text]');
  if(toggle && box && ta){
    toggle.addEventListener('change',function(){ box.hidden=!toggle.checked; ta.disabled=!toggle.checked; if(toggle.checked){ ta.focus(); } else { ta.value=''; } });
  }

  /* 7. « You may also like » : si le composant natif n'a pas encore chargé ses produits, on hydrate
        via l'API de rendu de section (même HTML que le thème), au chargement puis au premier scroll. */
  function hydrateRecs(){
    document.querySelectorAll('product-recommendations[data-recommendations-performed="false"]').forEach(function(el){
      if(el.dataset.fgHydrating || !el.dataset.productId || !el.dataset.sectionId) return; el.dataset.fgHydrating='1';
      var u=el.dataset.url+'&section_id='+encodeURIComponent(el.dataset.sectionId)+'&product_id='+el.dataset.productId+'&intent='+(el.dataset.intent||'related');
      fetch(u,{headers:{'Accept':'text/html'}}).then(function(r){return r.ok?r.text():'';}).then(function(html){
        if(!html) return; var d=new DOMParser().parseFromString(html,'text/html'); var fresh=d.querySelector('product-recommendations');
        if(fresh && fresh.querySelector('a[href*="/products/"]')){ el.innerHTML=fresh.innerHTML; el.setAttribute('data-recommendations-performed','true'); }
      }).catch(function(){});
    });
  }
  setTimeout(hydrateRecs,1200);
  window.addEventListener('scroll',hydrateRecs,{once:true,passive:true});

  /* 6. Galerie ↔ variante par alt text « variant:<valeur> » (convention, sans app) */
  function syncGalleryToVariant(){
    var vals=[].map.call(document.querySelectorAll('fieldset.variant-option input[type=radio]:checked'),function(i){return (i.value||'').toLowerCase();});
    if(!vals.length) return;
    var thumbs=document.querySelectorAll('[class*="thumbnail"] img, [class*="slideshow-controls"] img, button img');
    for(var i=0;i<thumbs.length;i++){
      var alt=(thumbs[i].getAttribute('alt')||'').toLowerCase();
      if(alt.indexOf('variant:')===0){
        var key=alt.replace('variant:','').trim();
        if(vals.indexOf(key)>-1){ var b=thumbs[i].closest('button, a, [role=button]'); if(b){ b.click(); } return; }
      }
    }
  }
})();
  } catch(e) { console.error(e); }
})();

})();
